import Vue from 'vue'
import ElementUI from 'element-ui'
import Resource from 'vue-resource'
import VueRouter from 'vue-router'
import routes from './routes'
import store from './store'
import VueVideoPlayer from 'vue-video-player'
import axios from 'axios'
import moment from 'vue-moment'
import CommonLogListDialog from 'components/modules/dialog/CommonLogListDialog'

// Resource logic
Vue.use(Resource);
Vue.http.options.emulateJSON = true;
Vue.use(VueRouter);
Vue.use(ElementUI);
Vue.use(ElementUI, {locale: 'en'});
Vue.use(moment);

// 注册自定义组件
Vue.component('commonLogListDialog', CommonLogListDialog);

// Import top level component
import App from './App.vue'
import 'bootstrap/dist/css/bootstrap.css'
//  for element 1.9.9 below
// import 'element-ui/lib/theme-default/index.css'
import 'element-ui/lib/theme-chalk/index.css'

// Routing logic
var router = new VueRouter({
  routes: routes,
  mode: 'history',
  linkActiveClass: 'open active',
  scrollBehavior: function (to, from, savedPosition) {
    return savedPosition || {x: 0, y: 0}
  }
});

// 权限控制
router.beforeEach(function (to, from, next) {
  if (to.meta.requiresAuth) { // 判断该路由是否需要登录权限
    if (store.state.isLogin) {
      next();
    } else {
      next({
        path: '/login?#'
        // query: {redirect: to.fullPath} // 将跳转的路由path作为参数，登录成功后跳转到该路由， 但会导致无权限的非法访问，因此屏蔽
      })
    }
  } else {
    next();
  }
});

// 请求默认值
axios.defaults.baseURL = '/api' // 开发环境借助ProxyTable； 生产环境借助Nginx

// Check local storage to handle refreshes
if (window.localStorage && window.localStorage.getItem('token')) {
  axios.defaults.headers.common['Authorization'] = 'token ' + window.localStorage.getItem('token')
  if (store.state.token !== window.localStorage.getItem('token')) {
    store.commit('SET_TOKEN', window.localStorage.getItem('token'))
  }
}
Vue.prototype.axios = axios

/**
 * 返回带有 Token 信息的请求头 （用于上传图片等）
 */
Vue.prototype.httpHead = function () {
  return {'Authorization': 'token ' + window.localStorage.getItem('token')}
}

/**
 * 返回 基础 URL（用于上传图片等）
 * @returns {string}
 */
Vue.prototype.httpBaseURL = function () {
  return axios.defaults.baseURL;
}
Vue.use(VueVideoPlayer);

// Some middleware to help us ensure the user is authenticated.

// Start out app!
// eslint-disable-next-line no-new
new Vue({
  el: '#app',
  router: router,
  store: store,
  render: h => h(App)
});

export default {
  components: {
    VueVideoPlayer
  }
}

require('bootstrap')
require('admin-lte')
//  require('../node_modules/admin-lte/dist/js/app.min.js')
require('../node_modules/admin-lte/dist/js/demo.js')
require('../node_modules/admin-lte/plugins/slimScroll/jquery.slimscroll.js')
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')



// WEBPACK FOOTER //
// ./src/main.js